import { Avatar, Divider, Grid } from "@mui/material";
import React from "react";
import { Formik } from "formik";
import moment from "moment";

import { StyledInstrumentDetailInfo } from ".";
import {
  borrowingInstrumentSchema,
  formatDateOfBirth,
  linkImage,
  useConstructionSites,
  linkAvatar,
} from "@utils";
import { AppDateRangePicker, AppCustomeSelect, PassChangeButton, AppTextArea } from "..";
import { timesheetApi } from "@api";
import { LABEL_CONSTRUCTIONSITE, PLACEHOLDER_CONSTRUCTIONSITE } from "@configs";
const queryString = require("query-string");
import "moment-timezone";
import { selectAuth, useAppSelector } from "@redux";
import { useTargetHistory } from "@utils";
import { useConstructionSelectionHistories } from "src/Utils/Hooks/useConstructionSelectionHistories";

interface IProps {
  product?: any;
  selectedDate?: any;
  handleOnSubmit: (values: any) => void;
}
export const InstrumentDetailInfoComponent = (props: IProps) => {
  const { product, selectedDate, handleOnSubmit } = props;
  const [optionSiteConstructions, setOptionSiteConstructions] = React.useState<any>([]);
  const parsed = queryString.parse(location.search);
  // hooks
  const { updateConstructionSiteHistory, sortConstructionSites } = useConstructionSites();

  const auth = useAppSelector(selectAuth);
  const id = auth.userInfo?.id;
  const { constructionList, fetchConstructionList, storeConstructionSelection } = useConstructionSelectionHistories(id ?? 0);

  // form value
  const initialValuesPackage = {
    condition: "",
    siteConstruction: "",
    comment: "",
  };
  //component states
  const [dateRate, setDateRate] = React.useState<any>({
    startDate: new Date(),
    endDate: new Date(),
  });

  const [comment, setComment] = React.useState<string>("");

  const { idConstuctionEmployeeSearch } = useAppSelector(selectAuth);
  const handleChangeDateRange = (e) => {
    setDateRate({ startDate: e.startDate, endDate: e.endDate });
  };

  React.useEffect(() => {
    setOptionSiteConstructions(constructionList);
  },[constructionList]);

  //現場名はhooksから履歴順に取得するのでAPIは使用しない
  // fetch api
  // const fetchListConstructions = async () => {
  //   try {
  //     const result = await timesheetApi.getListConstructions(idConstuctionEmployeeSearch);
  //     setOptionSiteConstructions(sortConstructionSites(result.data.data));
  //   } catch (err) { }
  // };
  React.useEffect(() => {
    setDateRate({
      startDate: selectedDate && formatDateOfBirth(selectedDate[0]),
      endDate: selectedDate && formatDateOfBirth(selectedDate[selectedDate?.length - 1]),
    });
    // fetchListConstructions();
  }, []);

  const targetHistory = useTargetHistory(product, parsed.itemId);
  return (
    <StyledInstrumentDetailInfo>
      <div className="InstrumentDetailInfo">
        <div className="infoTitle">
          <p className="infoTitleMain">{product?.title}</p>
          <div className="infoTitleSub">
            <p >{product?.category}</p>
          </div>
        </div>
        <Grid container>
          <Grid item xs={12} sm={12} md={12} lg={5}>
            <div className="info__detail">
              <div className="info__wrapper">
                <div className="info__imageWrapper">
                  <img
                    className="image"
                    src={linkImage(product?.img?.path)}
                    alt="detail product inventory"
                  />
                </div>
              </div>
            </div>
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={7}>
            <div className="info__infoWrapper">
              <span className="info__title">更新日時</span>
              <span className="info__number">
                {!!product?.lastUpdate &&
                  moment(product?.lastUpdate).format("YYYY/MM/DD・HH:mm")}
              </span>
            </div>
            <Divider />
            <div className="info__infoWrapper">
              <span className="info__title">校正日</span>
              <span className="info__number">
                {!!product?.inspection_at &&
                  moment(product?.inspection_at).format("YYYY/MM/DD")}
              </span>
            </div>
            <Divider />
            <div className="info__infoWrapper">
              <span className="info__title">棚</span>
              <span className="info__number">{product?.shelfNumber}</span>
            </div>
            <Divider />
            <div className="info__infoWrapper">
              <span className="info__title">URL</span>
              <span
                className="info__link"
                onClick={() => window.open(product?.url, "_blank")}
              >
                {product?.url}
              </span>
            </div>
            <Divider />
            {parsed.itemId ? (
              <div className="info__user">
                <div className="row">
                  <Avatar src={linkAvatar(targetHistory?.user?.avatar?.path)} />
                  <p style={{ paddingLeft: "1rem" }}>
                    {targetHistory?.user?.last_name}
                    {targetHistory?.user?.first_name}
                  </p>
                </div>
                <div className="row">
                  <p>現場名</p>
                  <p style={{ paddingLeft: "1rem" }}>
                    {targetHistory?.construction?.name}
                  </p>
                </div>
                <div className="row">
                  <p>持出</p>
                  <p style={{ paddingLeft: "1rem" }}>
                    {targetHistory?.from}
                  </p>
                </div>
                <div className="row">
                  <p>返却</p>
                  <p style={{ paddingLeft: "1rem" }}>{targetHistory?.to}</p>
                </div>
                <div className="row">
                  <p>補足メモ</p>
                  <p style={{ paddingLeft: "1rem" }}>{targetHistory?.comment}</p>
                </div>
              </div>
            ) : (
              <Formik
                initialValues={initialValuesPackage}
                enableReinitialize
                onSubmit={(values) => {
                  updateConstructionSiteHistory(values?.siteConstruction);

                  handleOnSubmit({
                    startDate: moment(dateRate.startDate).format("YYYY-MM-DD"),
                    endDate: moment(dateRate.endDate).format("YYYY-MM-DD"),
                    quantity: 1,
                    instrumentItemId: product.id,
                    construction_id: values.siteConstruction,
                    comment: values.comment,
                  });
                }}
                validationSchema={borrowingInstrumentSchema}
              >
                {({ handleSubmit, setFieldValue, values }) => {
                  return (
                    <div className="info__form">
                      <div style={{ paddingBottom: "1rem" }}>
                        <p style={{ paddingBottom: "1rem" }}>
                          {LABEL_CONSTRUCTIONSITE}
                        </p>
                        {!!optionSiteConstructions && (
                          <AppCustomeSelect
                            placeholder={PLACEHOLDER_CONSTRUCTIONSITE}
                            onChange={(e) => {
                              setFieldValue(
                                "siteConstruction",
                                e.value
                              );
                              storeConstructionSelection({user_id: id, selected_construction_id: e.value });
                            }}
                            groupContructions={optionSiteConstructions}
                            options={
                              optionSiteConstructions?.length &&
                              optionSiteConstructions?.map(
                                (item) => {
                                  return {
                                    label: item?.name,
                                    value: item?.id.toString(),
                                  };
                                }
                              )
                            }
                            name="siteConstruction"
                          />
                        )}
                      </div>
                      <label className="label">
                        補足メモ
                      </label>
                      <AppTextArea
                        name="comment"
                        handleChange={(value) => {
                          setFieldValue("comment", value);
                          setComment(value);
                        }
                        }
                        value={values.comment}
                      />
                      <AppDateRangePicker
                        value={{
                          startDate: dateRate?.startDate,
                          endDate: dateRate?.endDate,
                        }}
                        onChange={(e) => handleChangeDateRange(e)}
                        startText="持出"
                        endText="返却"
                      />
                      <div className="btn">
                        <PassChangeButton onClick={() => handleSubmit()}>決定</PassChangeButton>
                      </div>
                    </div>
                  );
                }}
              </Formik>
            )}
          </Grid>
        </Grid>
      </div>
    </StyledInstrumentDetailInfo>
  );
};
